<div class="row m-0">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-lg-12 col-sm-12 col-12">
          <h4 class="page-title content__title form__group__title">
            Información Empresa
          </h4>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <form validate [formGroup]="item" (ngSubmit)="onSubmit()" name="company_form" id="company_form" autocomplete="off">
      <div class="row">
        <div class="col-lg-9 col-12">
          <div class="row">
            <div class="form-group col-lg-9">
              <label>Razón social</label>
              <input type="text" class="form-control" formControlName="social_reason" required>
            </div>
            <div class="form-group col-lg-3">
              <label>N° RUC</label>
              <input type="text" class="form-control" formControlName="ruc" required>
            </div>
            <div class="form-group col-lg-6">
              <label>Nombre comercial</label>
              <input type="text" class="form-control" formControlName="tradename">
            </div>
            <div class="form-group col-lg-6">
              <label>Representante legal</label>
              <input type="text" class="form-control" formControlName="legal_representative">
            </div>
            <div class="form-group col-lg-12">
              <label>Dirección fiscal <span class="required"></span></label>
              <input type="text" class="form-control" formControlName="address" required>
            </div>
            <div class="form-group col-lg-4">
              <label>Departamento <span *ngIf="required_ubigeo" class="required"></span></label>
              <select class="form-control" [(ngModel)]="departmentSelected" (change)="changeDepartment()"
                [ngModelOptions]="{standalone: true}">
                <option value="0">Seleccione</option>
                <option *ngFor="let item of departments" [value]="item.code">{{ item.name }}</option>
              </select>
            </div>
            <div class="form-group col-lg-4">
              <label>Provincias<span *ngIf="required_ubigeo" class="required"></span></label>
              <select class="form-control" [(ngModel)]="provinceSelected" (change)="changeProvince()"
                [ngModelOptions]="{standalone: true}">
                <option value="null">Seleccione</option>
                <ng-container *ngIf="provinces.length > 0">
                  <option *ngFor="let item of provinces" [value]="item.code">{{ item.name }}</option>
                </ng-container>
              </select>
            </div>
            <div class="form-group col-lg-4">
              <label>Distritos <span *ngIf="required_ubigeo" class="required"></span></label>
              <select class="form-control" id="districtSelected" formControlName="ubigeo">
                <option value="null">Seleccione</option>
                <ng-container *ngIf="districts.length > 0">
                  <option *ngFor="let item of districts" [value]="item.code">{{ item.name }}</option>
                </ng-container>
              </select>
            </div>
            <div class="form-group col-lg-3">
              <label>Celular <span class="required"></span></label>
              <input type="text" class="form-control" formControlName="cellphone">
            </div>
            <div class="form-group col-lg-3">
              <label>Teléfono</label>
              <input type="text" class="form-control" formControlName="telephone">
            </div>
            <div class="form-group col-lg-6">
              <label>Correo electrónico</label>
              <input type="text" class="form-control" formControlName="email">
            </div>
            <div class="form-group col-lg-6">
              <label>Acerca de la empresa</label>
              <textarea rows="2" class="form-control no-resize" formControlName="activity_description"
                maxlength="100"></textarea>
            </div>
            <div class="form-group col-lg-6">
              <label>¿Qué ofrecemos?</label>
              <textarea rows="2" class="form-control no-resize" formControlName="offers_description"
                maxlength="100"></textarea>
            </div>
            <div class="form-group col-lg-6">
              <label>Ficha Ruc (PDF)</label>
              <ng-container *ngIf="item.value.url_file_ruc != null">
                <div class="row col-lg-12 col-12 p-0">
                  <div class="col-lg-9 col-8">
                    <a target="_blank" href="tenants/{{item.value.url_file_ruc}}"
                      class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                        class="far fa-file-pdf m-l-5"></i></a>
                  </div>
                  <div class="form-group col-lg-3 col-4">
                    <button (click)="removeFilePdf('url_file_ruc')" class="btn btn-outline-danger pointer w-100">
                      <i class="fas fa-minus-circle"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.value.url_file_ruc == null">
                <input id="url_file_ruc" class="form-control" type="file"
                  (change)="onFileSelected($event, 'url_file_ruc')" accept="application/pdf" />
              </ng-container>
            </div>
            <div class="form-group col-lg-6">
              <label>Otros docs: licencias,permisos,etc. (PDF)</label>
              <ng-container *ngIf="item.value.url_file_others != null">
                <div class="row col-lg-12 col-12 p-0">
                  <div class="col-lg-9 col-8">
                    <a target="_blank" href="tenants/{{item.value.url_file_others}}"
                      class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                        class="far fa-file-pdf m-l-5"></i></a>
                  </div>
                  <div class="form-group col-lg-3 col-4">
                    <button (click)="removeFilePdf('url_file_others')" class="btn btn-outline-danger pointer w-100">
                      <i class="fas fa-minus-circle"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.value.url_file_others == null">
                <input id="url_file_others" class="form-control" type="file"
                  (change)="onFileSelected($event, 'url_file_others')" accept="application/pdf" />
              </ng-container>
            </div>
            <div class="form-group col-lg-6">
              <label>Políticas empresa (PDF)</label>
              <ng-container *ngIf="item.value.url_file_policies != null">
                <div class="row col-lg-12 col-12 p-0">
                  <div class="col-lg-9 col-8">
                    <a target="_blank" href="tenants/{{item.value.url_file_policies}}"
                      class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                        class="far fa-file-pdf m-l-5"></i></a>
                  </div>
                  <div class="form-group col-lg-3 col-4">
                    <button (click)="removeFilePdf('url_file_policies')" class="btn btn-outline-danger pointer w-100">
                      <i class="fas fa-minus-circle"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.value.url_file_policies == null">
                <input id="url_file_policies" class="form-control" type="file"
                  (change)="onFileSelected($event, 'url_file_policies')" accept="application/pdf" />
              </ng-container>
            </div>
            <div class="form-group col-lg-6">
              <label>Resumen empresa PDF</label>
              <ng-container *ngIf="item.value.url_file_summary != null">
                <div class="row col-lg-12 col-12 p-0">
                  <div class="col-lg-9 col-8">
                    <a target="_blank" href="tenants/{{item.value.url_file_summary}}"
                      class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                        class="far fa-file-pdf m-l-5"></i></a>
                  </div>
                  <div class="form-group col-lg-3 col-4">
                    <button (click)="removeFilePdf('url_file_summary')" class="btn btn-outline-danger pointer w-100">
                      <i class="fas fa-minus-circle"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="item.value.url_file_summary == null">
                <input id="url_file_summary" class="form-control" type="file"
                  (change)="onFileSelected($event, 'url_file_summary')" accept="application/pdf" />
              </ng-container>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-12">
              <p class="form__group__title f-s-14 p-b-5"><i class="fas fa-align-left m-r-5"></i>Datos Sucursal ()</p>
              <p>Datos para el envio al api de comprobantes electrónicos</p>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Api facturador<span class="required"></span></label>
                  <input type="text" class="form-control" required>
                </div>
                <div class="form-group col-lg-4">
                  <label>Token usuario<span class="required"></span></label>
                  <input type="text" class="form-control" required>
                </div>
                <div class="form-group col-lg-4">
                  <div class="custom-control custom-checkbox m-t-25">
                    <input type="checkbox" class="custom-control-input" id="send_billing">
                    <label class="custom-control-label p-t-3" for="send_billing">¿Habilitar envio de
                      comprobantes?</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <p class="text-center p-t-15">
            <ng-container *ngIf="item.value.url_image != null">
              <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
            </ng-container>
            <ng-container *ngIf="item.value.url_image == null">
              <ng-container *ngIf="imageUrl == null">
                <img id="output" width="200" src="/images/default.png" />
              </ng-container>
              <ng-container *ngIf="imageUrl != null">
                <img width="200" height="165" [src]="imageUrl" alt="Preview">
              </ng-container>
            </ng-container>
          </p>
          <p class="text-center">
            <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
              Seleccionar Imagen
              <input id="file" type="file" (change)="onFileSelectedImg($event)" accept=".png, .jpg, .jpeg"
                style="visibility: hidden;">
            </label>
          </p>
        </div>
        <div class="form-group col-lg-12 form__footerBtn">
          <div class="text-right">
            <a class="btn btn-secondary text-white" (click)="cancel()">Volver a cargar</a>
            <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="item.invalid">
              <i class="far fa-save m-r-5"></i>
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
